// extracted by mini-css-extract-plugin
export default {"details__topBarContainer":"ProjectDetails_details__topBarContainer__O1nOP","details__actions":"ProjectDetails_details__actions__mgg6f"};